import { ResponsiveUtils } from "@allwyn/utils/responsive-utils";
import { MainMenuAnalytics } from "../header-stack/header-stack-partials/main-menu/main-menu-analytics";

let isFooterInitialized = false;

function getControlledRegion(button: HTMLButtonElement): HTMLElement | null {
    const regionId = button.getAttribute("aria-controls");
    const region = regionId ? document.getElementById(regionId) : null;
    return region?.classList.contains("footer-links__group-body") ? region : null;
}

function syncRegion(button: HTMLButtonElement, region: HTMLElement, isDesktop: boolean): void {
    const isOpen = button.closest(".footer-links__group")?.classList.contains("is-open") === true;
    const isHidden = !isDesktop && !isOpen;

    region.setAttribute("aria-hidden", String(isHidden));
    region.toggleAttribute("inert", isHidden);
    button.setAttribute("aria-expanded", String(isOpen));
}

function handleFooterClick(event: Event): void {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(".footer-links")) return;

    const button = event.target.closest<HTMLButtonElement>(".footer-links__group-button");
    if (button) {
        const group = button.closest(".footer-links__group");
        const region = getControlledRegion(button);
        if (!group || !region) return;

        group.classList.toggle("is-open");
        syncRegion(button, region, ResponsiveUtils.breakpointUp("sm"));
        return;
    }

    const link = event.target.closest<HTMLAnchorElement>(".footer-links__link[data-a-codename]");
    const analyticsCodeName = link?.dataset.aCodename;
    if (analyticsCodeName) MainMenuAnalytics.pushButtonClick(analyticsCodeName, "footer");
}

export const useFooter = (): void => {
    if (isFooterInitialized) return;

    const desktopMedia = window.matchMedia(`(min-width: ${ResponsiveUtils.breakpoints.sm}px)`);
    const syncRegions = (): void => {
        document.querySelectorAll<HTMLButtonElement>(".footer-links .footer-links__group-button").forEach((button) => {
            const region = getControlledRegion(button);
            if (region) syncRegion(button, region, desktopMedia.matches);
        });
    };

    document.addEventListener("click", handleFooterClick);
    desktopMedia.addEventListener("change", syncRegions);
    syncRegions();
    isFooterInitialized = true;
};
